/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseStatus } from '../../models/base-status';
import { GetBasesResponse } from '../../models/get-bases-response';

export interface ListBases$Params {
  page?: number;
  size?: number;

/**
 * `field,direction`. Fields: `name`, `code`, `status`, `baseLead` (by Base Lead name), `location`, `timeZone`, `createdAt`, `lastModifiedAt`. Direction `asc` or `desc` (default `asc`). Text sorts ignore letter case, Bases with an empty Base Lead, Location, or Time Zone are always listed last, and ties fall back to Base Name then id so paging is stable. An unknown field or direction is a 400.
 */
  sort?: string;
  search?: string;

/**
 * Optional multi-select shift filter. Omit or empty = no shift filter. Each value is a Base shift `id` taken from `GET /api/scheduler/bases/shifts`. A Base is returned if it owns at least one of the listed shifts. An unknown shift id is a 400.
 */
  shifts?: Array<number>;

/**
 * Optional. Omit = Active and Inactive Bases. Combines with search and shifts.
 */
  status?: BaseStatus;
}

export function listBases(http: HttpClient, rootUrl: string, params?: ListBases$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBasesResponse>> {
  const rb = new RequestBuilder(rootUrl, listBases.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
    rb.query('shifts', params.shifts, {"style":"form","explode":true});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBasesResponse>;
    })
  );
}

listBases.PATH = '/api/scheduler/bases';
